import { FormlyFieldConfig } from "@ngx-formly/core";
import { AllegatiNullaOstaStep } from "./steps/allegati-nullaosta.step";
import { RichiestaNullaOstaStep } from "./steps/richiesta-nullaosta.step";
import { PrivacyDelegaStep } from "app/forms/shared/privacy-delega.step";
import { IntestatarioStep } from "app/forms/shared/intestatario.step";
import { GiuridicaStep } from "app/forms/shared/giuridica.step";
import { UbicazioneStep } from "../shared/ubicazione.step";
import { IntestatarioTipo } from "app/forms/shared/intestatario.tipo";

export const NullaOsta: FormlyFieldConfig[] = [
        {
            props: {
                slabel: "PRIVACY",
                label: "INFORMATIVA SULLA PRIVACY"
            },
            wrappers: ['panel-step'],
            fieldGroup: PrivacyDelegaStep
        },
        {
            props: {
                slabel: "INTESTATARIO",
                label: "DATI ANAGRAFICI INTESTATARIO"
            },
            wrappers: ['panel-step'],
            fieldGroup: [...IntestatarioTipo, ...IntestatarioStep, ...GiuridicaStep]
        },
        {
            props: {
                slabel: "UBICAZIONE",
                label: "UBICAZIONE DEL CANTIERE IN MAPPA",
            },
            wrappers: ['panel-step'],
            fieldGroup: UbicazioneStep
        },
      {
        props: {
          slabel: 'RICHIESTA',
          label: 'DATI DELLA RICHIESTA'
        },
        wrappers: ['panel-step'],
        fieldGroup: RichiestaNullaOstaStep
      },
      {
        props: {
          slabel: 'ALLEGATI',
          label: 'DOCUMENTAZIONE ALLEGATA'
        },
        wrappers: ['panel-step'],
        fieldGroup: AllegatiNullaOstaStep
      },
    ]


